"use client";

export { create as createModal, useModal } from "@ebay/nice-modal-react";
